<template>
  <v-chip
    class='ma-2 w-table-chips'
    :color='color'
    small
    outlined
  >
    <slot name='default' />
  </v-chip>
</template>

<script>
export default {
  name: 'WorkTableChips',
  props: {
    color: { type: String, default: 'secondary_font_color' }
  }
};
</script>

<style lang="scss" scoped>
  .v-chip.v-size--small{
    height: 1.25rem !important;
    font-size: 0.875rem  !important;
  }
</style>
